<script>

  import { External, M } from '../../external';
  import { onMount } from 'svelte';
  import { makeWebsiteRequest } from '../../Common/tools';

  export let url = '';
  let changed = false;
  let onChange = () => {
    url = External.Tools.urlFromString(url, false, false, '-', true);
    changed = true;
  };

  let onCancel = () => {
    changed = false;
    url = WebPlatform.lmsBase;
  };

  let onSave = async () => {
    await makeWebsiteRequest({
      action: 'setLmsUrl',
      data: {
        url: url
      }
    });
    WebPlatform.lmsBase = url;
    External.Tools.showAutohideMessage(1000, M.UPDATED);
    changed = false;
  };

  onMount(() => {
    url = External.WebPlatform.lmsBase;
  });

</script>

<div class="account-settings overflow store-products flex-1 col20" style="font-family: 'Roboto';">

  <div class="top-background-wrapper narrow-top-background">
    <div class="top-background">
      <div class="text-wrapper f-left col20 flex align-center space-between">
        <div class="flex-centered flex-col-mobile f-left flex" style="display: flex;">
          <h2 class="crm-title f-left crm-title-bigger">{M.CIRCLE_PAGE_SETTINGS} <i class="fa fa-circle"></i></h2>
        </div>
      </div>
    </div>
  </div>
  <div class="content-wrapper horizontal-flex-table">
    <div class="sections-wrapper members-wrapper horizontal-flex-table">
      <div class="sections-wrapper profile-inner-wrapper bg-white box-shadow padding-45 f-left col20">

        <!-- Community Settings -->
        <div class="col20 f-left getting-started-layout flex light-bg mb-15" style="border-radius: 10px;">
          <div class="col11 f-left flex justify-center flex-col">
            <h2 class="col20 f-left mt-10 mb-15">{M.CIRCLE_PAGE_SETTINGS}</h2>
            <span class="col20 f-left paragraph-text mb-25">{M.CIRCLE_PAGE_SETTINGS_DESC}</span>
          </div>
          <div class="col9 f-left justify-center align-center flex">
            <div class="col20 f-left flex flex-col">
              <section class="col20 f-left input-area">
                <h5>{M.CIRCLE_PAGE_URL}</h5>
                <span>{M.CIRCLE_PAGE_URL_DESC}</span>
                <input type="text" bind:value={url} on:input={onChange} placeholder="{M.TYPE_NESTED_URL}">
              </section>
            </div>
          </div>
        </div>

        <div class="col20 f-left getting-started-layout flex light-bg" style="border-radius: 10px;">
          <div class="col11 f-left flex justify-center flex-col">
            <h2 class="col20 f-left mt-10 mb-15">{M.CIRCLE_PAGE_TEMPLATE}</h2>
            <span class="col20 f-left paragraph-text mb-25">{M.CIRCLE_PAGE_TEMPLATE_DESC}</span>
            <div class="col20 f-left"><a class="blue middle-button" rel="tab" href="/me/website/system/community">{M.EDIT_PAGE_TEMPLATE}</a></div>
          </div>
          <div class="col9 f-left justify-center align-center flex">
            <div class="col20 f-left flex align-center justify-center">
              <div class="big-icon-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M120-386.92v-186.16q0-27.61 19.65-47.27Q159.31-640 186.92-640q27.62 0 47.27 19.65 19.66 19.66 19.66 47.27v186.16q0 27.61-19.66 47.27Q214.54-320 186.92-320q-27.61 0-47.27-19.65Q120-359.31 120-386.92ZM373.85-240q-27.62 0-46.12-18.5-18.5-18.5-18.5-46.12v-350.76q0-27.62 18.5-46.12 18.5-18.5 46.12-18.5h212.3q27.62 0 46.12 18.5 18.5 18.5 18.5 46.12v350.76q0 27.62-18.5 46.12-18.5 18.5-46.12 18.5h-212.3Zm332.3-146.92v-186.16q0-27.61 19.66-47.27Q745.46-640 773.08-640q27.61 0 47.27 19.65Q840-600.69 840-573.08v186.16q0 27.61-19.65 47.27Q800.69-320 773.08-320q-27.62 0-47.27-19.65-19.66-19.66-19.66-47.27ZM373.85-280h212.3q10.77 0 17.7-6.92 6.92-6.93 6.92-17.7v-350.76q0-10.77-6.92-17.7-6.93-6.92-17.7-6.92h-212.3q-10.77 0-17.7 6.92-6.92 6.93-6.92 17.7v350.76q0 10.77 6.92 17.7 6.93 6.92 17.7 6.92ZM480-480Z"/></svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {#if changed}
    <div class="floating-lane t-center save-float" style="display: block;">
      <div class="content-wrapper">
        <a class="middle-button blue f-none inline-block mr-15" on:click={onSave}>
          {M.SAVE_CHANGES}
        </a>
        <a on:click={onCancel} class="text-button f-none inline-block">
          Cancel
        </a>
      </div>
    </div>
  {/if}
</div>
